// extracted by mini-css-extract-plugin
export default {"overlay":"LanguageOverlay_overlay_mTIB3"};